<template>
	<div v-if="showMetrics" class="performance-monitor">
		<div class="metrics-container">
			<div v-for="(value, key) in metrics" :key="key" class="metric-item">
				<span class="metric-label">{{ formatMetricName(key) }}:</span>
				<span class="metric-value">{{ formatMetricValue(value) }}</span>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { collectPerformanceMetrics } from '@/utils/performance'

const { t } = useI18n()
const showMetrics = ref(false)
const metrics = ref<any>({})

const formatMetricName = (name: string) => {
	const nameMap: { [key: string]: string } = {
		loadTime: t('performance.loadTime'),
		domReady: t('performance.domReady'),
		fcp: t('performance.fcp'),
		lcp: t('performance.lcp'),
		fid: t('performance.fid'),
		cls: t('performance.cls')
	}
	return nameMap[name] || name
}

const formatMetricValue = (value: number) => {
	if (typeof value !== 'number') {
		return 'N/A'
	}
	if (value < 1000) {
		return `${value.toFixed(2)}ms`
	}
	return `${(value / 1000).toFixed(2)}s`
}

onMounted(() => {
	// 等待页面完全加载
	window.addEventListener('load', () => {
		setTimeout(() => {
			metrics.value = collectPerformanceMetrics()
			showMetrics.value = true
		}, 1000)
	})
})
</script>

<style scoped>
.performance-monitor {
	position: fixed;
	bottom: 20px;
	right: 20px;
	background: rgba(0, 0, 0, 0.8);
	color: #fff;
	padding: 10px;
	border-radius: 4px;
	font-size: 12px;
	z-index: 9999;
}

.metrics-container {
	display: flex;
	flex-direction: column;
	gap: 5px;
}

.metric-item {
	display: flex;
	justify-content: space-between;
	gap: 10px;
}

.metric-label {
	color: #ccc;
}

.metric-value {
	color: #4caf50;
}
</style>
